<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/biglogo.png" alt="yuanzhuo..." />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0,0)"
          :text-color="navBackground"
          :active-text-color="navBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首页</el-menu-item>
          <el-menu-item index="2" class="menu_item"
            >产品案例
            <!-- <template slot="title"></template> -->
            <!-- <el-menu-item index="2-1" class="menu_item">产品案例</el-menu-item>
            <el-menu-item index="2-2" class="menu_item">云招商</el-menu-item>
            <el-menu-item index="2-3" class="menu_item"
              >企业创新服务</el-menu-item
            >
            <el-menu-item index="2-4" class="menu_item">产业咨询</el-menu-item> -->
          </el-menu-item>
          <el-menu-item index="3" class="menu_item">开发建议</el-menu-item>
          <el-menu-item index="5" class="menu_item"
            >产品订阅
            <!-- <template slot="title">内容中心</template>
            <el-menu-item index="4-1" class="menu_item">行业报告</el-menu-item>
            <el-menu-item index="4-2" class="menu_item">精选文章</el-menu-item>
            <el-menu-item index="4-3" class="menu_item">媒体报道</el-menu-item>
          </el-submenu> -->
          </el-menu-item>
          <el-menu-item index="tt" class="menu_item">留言咨询</el-menu-item>
          <!-- <el-menu-item index="5" class="menu_item">合作咨询</el-menu-item> -->
          <!-- <el-submenu index="5">
            <template slot="title">了解云逸</template>
            <el-menu-item index="5-1" class="menu_item">云逸介绍</el-menu-item>
          
            <el-menu-item index="5-4" class="menu_item">联系云逸</el-menu-item>
          </el-submenu> -->

          <div class="right_menu" v-if="isLogin == false">
            <el-menu-item index="8" class="menu_item"> 登录</el-menu-item>
            <el-menu-item index="9" class="menu_item"> 注册</el-menu-item>
          </div>
          <div class="right_menu" v-if="isLogin">
    <img class="user_avatar" src="@/assets/img/userimg.png" alt="" />
    <el-popover
      placement="bottom"
      trigger="click"
      v-model="showPopover"
    >
      <template #reference>
        <el-menu-item index="10" class="menu_item">用户{{phoneLastDigits  }}</el-menu-item>
      </template>
      <div class="logout-option">
        <el-button type="text" @click="logout">退出登录</el-button>
      </div>
    </el-popover>
  </div>
          <!-- <el-menu-item index="5-1" class="menu_item">云逸介绍</el-menu-item> -->
        </el-menu>

        <!-- <a href="#">立即体验</a> -->
        <!-- <span class="right_phone">
          <i class="el-icon-phone"></i>
          <span> 000-000-0000 </span>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      showPopover: false,
     
      isok: localStorage.getItem("userId"),
      messageOptions: [
        { value: "合作咨询", label: "合作咨询" },
        { value: "反馈意见", label: "反馈意见" },

        { value: "新增需求", label: "新增需求" },
      ], // 这里存储从接口获取并处理后的选项数组
      activeIndex: "1",
      navBackground: "#fff",
    };
  },
  props: {
    selectIndex: {
      type: String,
      default: "0",
    },
  },

  computed: {
    // isLoggedIn() {
    //   const token = localStorage.getItem("token");
    //   return token !== null; // token 存在则返回 true
    // } ,
    ...mapGetters(["isLogin"]), // 确保映射 isLogin getter
    ...mapGetters(["usedialogVisible"]),
    phoneLastDigits() {
      return localStorage.getItem("phonedigits");
    }
  },

  mounted() {
    const token = localStorage.getItem("token");

    const phonedigits = localStorage.getItem("phonedigits");
    this.$store.dispatch('setPhoneLastDigits', phonedigits);
    if(token !== null){
      this.$store.commit("SET_LOGIN", true);
    }
    this.activeIndex = this.selectIndex;
    window.onscroll = () => {
      if (document.documentElement.scrollTop > 390) {
        this.navBackground = "#fff";
      } else {
        this.navBackground = "#fff";
      }
    };
  },
  methods: {
    logout() {
      // 清除 token
      localStorage.removeItem('token'); // 假设 token 存储在 localStorage 中
      localStorage.removeItem('userId'); // 假设 token 存储在 localStorage 中
      localStorage.removeItem('phonedigits'); // 假设 token 存储在 localStorage 中
      
      // 刷新页面
      window.location.href = '/home';
      this.$nextTick(() => {
            this.$store.commit("setusedialogVisible",false);
          });
     
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
 
    changeCurrentPage(index) {
      this.activeIndex = index;
      switch (this.activeIndex) {
        case "1":
          this.$router.push("/home").catch((v) => {});
          break;
        case "2":
          this.$router.push("/production/1").catch((v) => {});
          break;
        case "2-2":
          this.$router.push("/production/2").catch((v) => {});
          break;
        case "2-3":
          this.$router.push("/production/3").catch((v) => {});
          break;
        case "2-4":
          this.$router.push("/production/4").catch((v) => {});
          break;
        case "3":
          this.$router.push("/threenav").catch((v) => {});
          break;
        case "4":
          this.$router.push("/fournav/1").catch((v) => {});
          break;
        case "4-2":
          this.$router.push("/fournav/2").catch((v) => {});
          break;
        case "4-3":
          this.$router.push("/fournav/3").catch((v) => {});
          break;
        case "tt":
        
        // this.$router.push("/wxLogin").catch((v) => {});
          this.$nextTick(() => {
            this.$store.commit("setusedialogVisible", true);
          });

          // this.$router.push("/fournav/3").catch((v) => {});
          break;
        case "5":
          var token = localStorage.getItem("token");
          // console.log(token);

          if (token == null) {
            // this.$router.push("/home").catch((v) => {});
            this.$nextTick(() => {
              this.$store.commit("setDialogVisible", true);
            });
          } else {
            this.$router.push("/fivenav/1").catch((v) => {});
          }

          break;
        case "5-2":
          this.$router.push("/fivenav/2").catch((v) => {});
          break;
        case "5-3":
          this.$router.push("/fivenav/3").catch((v) => {});
          break;
        case "5-4":
          this.$router.push("/fivenav/2").catch((v) => {});
          break;
        case "6":
          this.$router.push("/demo").catch((v) => {});
          break;

        case "8":
          if (token == null) {
            // this.$router.push("/home").catch((v) => {});
            this.$nextTick(() => {
              this.$store.commit("setDialogVisible", true);
              this.$store.commit("setUseisRegister", false);
            });
          } else {
            // this.$store.commit("setDialogVisible", true);
          }
          break;
        case "9":
          if (token == null) {
            // this.$router.push("/home").catch((v) => {});
            this.$nextTick(() => {
              this.$store.commit("setDialogVisible", true);
              this.$store.commit("setUseisRegister", true);
            });
          } else {
            // this.$store.commit("setDialogVisible", true);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: #0e206c;

  // backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 50px;
      margin-right: -101px;
      img {
        width: 300px;
        height: 45px;
        cursor: pointer;
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-left: 117px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: 0%;
        display: flex;
        align-items: center;
        &:hover {
          font-weight: 400;
          background: transparent !important;
        }
      }
      .right_phone {
        &:hover {
          color: #ccc;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #fff;
      }
    }
  }
}

.right_menu {
  display: flex;
  align-items: center;
  margin-left: 800px;
  justify-content: right;

  img {
    width: 30px;
    height: 30px;
  }
}
.leave-message {
  margin-bottom: 20px;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 100px;
  height: 100px;
}
.custom-dialog .el-dialog__header {
  border-top: 1px solid #ccc; /* 灰色线 */
}

.dialog-header-line {
  border-top: 1px solid #ccc; /* 灰色线 */
  margin: -1px; /* 调整边距 */
}
.el-menu--horizontal .el-menu-item.is-active {
  font-weight: bold !important;
}
.logout-option {
  padding: 10px;
  text-align: center;
}
::v-deep .el-popover {
    position: absolute;
    background: #FFF;
    min-width: 92px;
    border-radius: 0.20833vw;
    border: 1px solid #EBEEF5;
    /* padding: 0.625vw; */
    z-index: 2000;
    color: #606266;
    line-height: 4.4;
    text-align: justify;
    font-size: 0.72917vw;
    box-shadow: 0 0.10417vw 0.625vw 0 rgba(0, 0, 0, .1);
    word-break: break-all;
}
</style>
